import React, { useState, useEffect, useRef, useContext } from "react";
import { Button } from "react-bootstrap";
import RoundedSearchTextField from "./ModuleSearchField.js";
import "../../styles/components/ModulesScreen.scss";
import ModuleCardNew from "./ModuleCardNew.js";
import Switch from "@mui/material/Switch";
import { deleteAsset, getmmModules } from "../../services/apis.js";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory, useLocation } from "react-router-dom";
import checkMark from "../../images/bluecheckbox.svg";
import ValueContext from "../../ContextAPi/appContext";
import CannotExist from "../../images/Cannotexist.svg";
import MustExist from "../../images/MustExist.svg";
import NoResultsFound from "../../images/Noresults.svg";
import clearTextIcon from "../../images/clearTextIcon.svg";
import ModuleView from "../../components/ModulePreview/ModuleView.js";
import { CircularProgress } from "@mui/material";
import BannerHeaderModule from "./BannerHeaderModule.js";
import BannerConfirmationModal from "../BannerManager/BannerConfirmationModal.js";
import ImportModule from "../../../src/images/importModule.svg";
import IndicationFilter from "./SearchAndFilter.js";

const ModulesScreen = ({
  selectedChecked,
  handleSwitchComp,
  handleOpenModal,
  setModulesData,
  modulesData,
  selectedModulecards,
  setSelectedModulecards,
  setSearchText,
  searchText,
  brandName,
  countryName,
  setOpenModulesModal,
  moduleCardsDataLHS,
  handleGotoEditor,
  setOpenModulesScreen,
  setOpenRuleSetModal,
  setIsNext,
  moduleSearchExpression,
  setBgClass,
  setModulePreviewOpen,
  modulePreviewData,
  modulePreviewOpen,
  getModuleDetailsForPreview,
  submittedQuery,
  setSubmittedQuery,
  currentPage,
  setCurrentPage,
  state,
  selectedIndications,
  setSelectedIndications,
  hasMore,
  isLoading,
  setRemoveSymbol,
}) => {
  const scrollableDivRef = useRef(null);
  const history = useHistory();
  const [search, setSearch] = useState(false);
  const [isSearchBarEmpty, setIsSearchBarEmpty] = useState(true);
  const searchReference = useRef();
  const initialFvalues = { moduleNameArray: "" };
  const [values, setValues] = useState(initialFvalues);
  const [searchInitated, setSearchInitated] = useState(false);
  const [mustExistData, setMustExistData] = useState([]);
  const [relationalData, setRelationalData] = useState([]);
  const [cannotExistData, setCannotExistData] = useState([]);
  const [contextMenu, setContextmenu] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isClickCard, setIsClickcard] = useState(false);
  const appData = useContext(ValueContext);

  const handleCancel = () => setShowConfirmation(false);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedIndications]);

  const deleteBanner = async () => {
    let damDocNumber = localStorage.getItem("damDocNumber") || "";
    deleteAsset(damDocNumber, (response, err) => {
      if (response.status === 200) {
        setBgClass(false);
        // localStorage.removeItem("modulesSelected");
        appData.setBanner(true);
        setShowConfirmation(false);
        setOpenModulesModal(false);
        setSelectedModulecards([]);
        history.push("/");
      } else {
        console.log(err, "error");
      }
    });
  };

  const handleProceed = () => {

    if (appData?.newBanner) {
      deleteBanner();
    } else {
      setBgClass(false);
      // localStorage.removeItem("modulesSelected");
      appData.setBanner(true);
      setShowConfirmation(false);
      setOpenModulesModal(false);
      setSelectedModulecards([]);
    }
    history.push("/");
  };

  const storedProps = {
    showBannertype: appData.bannerType,
    showBannerName: appData.bannerName,
    tempNamebanner: "Banner",
    showAssettype: "Banner",
  };

  // useEffect(() => {
  //   if (!isClickCard) {

  //     console.log(selectedModulecards)
  //     for (let i = 0; i < selectedModulecards?.length; i++) {
  //       handleMustExistAndCannotExist(selectedModulecards[i]?.id);
  //     }
  //   }
  // }, [selectedModulecards]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!isClickCard) {
      const validModules = selectedModulecards.filter(
        (module) => module.mlrStatus !== "Expired"
      );

      if (validModules.length !== selectedModulecards.length) {
        setSelectedModulecards(validModules);
        return;
      }
      validModules.forEach((module) => {
        handleMustExistAndCannotExist(module.id);
      });
    }
  }, [selectedModulecards]);

  const handleClearSearchOnly = () => {
    setSearchText("");
    setSubmittedQuery("");
    setCurrentPage(1);
    setSearchInitated(false);
    setIsSearchBarEmpty(true);
  };

  const handleResetAllFilters = () => {
    setIsSearchBarEmpty(true);
    setValues({ ...values, moduleNameArray: "" });
    setSearchText("");
    setSubmittedQuery("");
    setSelectedIndications([]);
    setCurrentPage(1);
    setSearchInitated(false);
  };

  const selectDeselectModule = (item) => {

    if (
      mustExistData.includes(item.id) ||
      cannotExistData.includes(item.id) ||
      relationalData.includes(item.id)
    ) {
      return;
    }
    setIsClickcard(true);

    const isSelected = selectedModulecards.some(
      (module) => module.moduleDamName === item.moduleDamName
    );

    const isRequiredByOthers = (moduleId) => {
      return selectedModulecards.some((module) => {
        if (module.id === moduleId) return false;
        return module.moduleBusinessRules.some(
          (rule) =>
            (rule.ruleCondition === "MustExistWith" &&
              rule.targetModuleId === moduleId) ||
            (rule.ruleCondition === "CannotExistWith" &&
              rule.targetModuleId === moduleId) ||
            (rule.ruleCondition === "Optional" &&
              rule.targetModuleId === moduleId)
        );
      });
    };

    if (isSelected) {
      if (isRequiredByOthers(item.id)) return;

      setSelectedModulecards((prev) =>
        prev.filter((module) => module.moduleDamName !== item.moduleDamName)
      );
      // localStorage.setItem(
      //   "modulesSelected",
      //   JSON.stringify(
      //     selectedModulecards.filter(
      //       (module) => module.moduleDamName !== item.moduleDamName
      //     )
      //   )
      // );
      removeCannotExistAndMustExistIds(item.id);
    } else {
      handleMustExistAndCannotExist(item.id);
      setSelectedModulecards((prev) => [...prev, item]);
      // localStorage.setItem(
      //   "modulesSelected",
      //   JSON.stringify([...selectedModulecards, item])
      // );
    }
  };

  const handlePageChange = (page) => setCurrentPage(page);
  const initiateSearch = () => {
    const term = (searchText || "").trim();
    if (term !== "") {
      setSearch(true);
      setValues({ ...values, moduleNameArray: term });
    }
    setSubmittedQuery(term);
    setCurrentPage(1);
    setSearchInitated(!!term);
  };

  const handleMustExistAndCannotExist = (id) => {
    const selectedModule = modulesData.find((module) => module.id === id);
    if (!selectedModule) return;

    const selectedModuleIds = selectedModulecards.map((card) => card.id);

    const mustExist = selectedModule.moduleBusinessRules.filter(
      (rule) => rule.ruleCondition === "MustExistWith"
    );
    const cannotExist = selectedModule.moduleBusinessRules.filter(
      (rule) => rule.ruleCondition === "CannotExistWith"
    );
    const relationalExist = selectedModule.moduleBusinessRules.filter(
      (rule) => rule.ruleCondition === "Optional"
    );

    const mustExistIds = mustExist
      .map((rule) => rule.targetModuleId)
      .filter((id) => !selectedModuleIds.includes(id));
    const cannotExistIds = cannotExist
      .map((rule) => rule.targetModuleId)
      .filter((id) => !selectedModuleIds.includes(id));
    const relationalExistIds = relationalExist
      .map((rule) => rule.targetModuleId)
      .filter((id) => !selectedModuleIds.includes(id));

    if (mustExistIds.length > 0)
      setMustExistData((prev) => [...prev, ...mustExistIds]);
    if (cannotExistIds.length > 0)
      setCannotExistData((prev) => [...prev, ...cannotExistIds]);
    if (relationalExistIds.length > 0)
      setRelationalData((prev) => [...prev, ...relationalExistIds]);
  };

  const removeCannotExistAndMustExistIds = (id) => {
    const selectedModule = modulesData.find((module) => module.id === id);
    if (!selectedModule) return;

    const mustExistIds = selectedModule.moduleBusinessRules
      .filter((rule) => rule.ruleCondition === "MustExistWith")
      .map((rule) => rule.targetModuleId);

    const cannotExistIds = selectedModule.moduleBusinessRules
      .filter((rule) => rule.ruleCondition === "CannotExistWith")
      .map((rule) => rule.targetModuleId);

    const relationalExistIds = selectedModule.moduleBusinessRules
      .filter((rule) => rule.ruleCondition === "Optional")
      .map((rule) => rule.targetModuleId);

    setMustExistData((prev) => prev.filter((x) => !mustExistIds.includes(x)));
    setCannotExistData((prev) =>
      prev.filter((x) => !cannotExistIds.includes(x))
    );
    setRelationalData((prev) =>
      prev.filter((x) => !relationalExistIds.includes(x))
    );
  };

  const displayRulesClass = (id) => {
    if (mustExistData.includes(id)) return "mustExistWithCards";
    if (cannotExistData.includes(id)) return "cannotExistWithCards";
    if (relationalData.includes(id)) return "mustExistWithCards";
    return "";
  };

  function createdDate(dateString) {
    const createdDate = new Date(dateString);
    const currentDate = new Date();
    createdDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    const daysDifference = Math.floor(
      (currentDate - createdDate) / (1000 * 60 * 60 * 24)
    );
    if (daysDifference === 0) return "Today";
    if (daysDifference === 1) return "Yesterday";
    return `${daysDifference} Days Ago`;
  }

  const handleCloseContextMenu = () => setContextmenu(false);

  return (
    <div className="module-screen">
      {modulePreviewOpen && (
        <ModuleView
          modulePreviewData={modulePreviewData}
          setModulePreviewOpen={setModulePreviewOpen}
          modulePreviewOpen={modulePreviewOpen}
        />
      )}

      <div className="modulesRow">
        <BannerHeaderModule
          editorProps={storedProps}
          setShowConfirmation={setShowConfirmation}
          fromModule={true}
        />

        <div className="middle-pannel-header-module">
          <img
            className="journeyBarImageModule"
            alt="Journey Bar"
            src={ImportModule}
          />
        </div>

        <div
          className="d-flex "
          style={{
            gap: "12px",
            marginTop: "15px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <p className="selectModule">Select one or more Module</p>

          <span
            style={{
              borderLeft: "1px solid #ccc",
              paddingLeft: "12px",
              marginBottom: "10px",
            }}
          >
            Product: <strong>{brandName || state?.brandName || "N/A"}</strong>
          </span>

          <span
            style={{
              borderLeft: "1px solid #ccc",
              paddingLeft: "12px",
              marginBottom: "10px",
            }}
          >
            Country:{" "}
            <strong>{countryName || state?.countryName || "N/A"}</strong>
          </span>
        </div>

        <div className="filters-row">
          <div className="filters-col">
            <IndicationFilter
              value={selectedIndications}
              onChange={setSelectedIndications}
              wrapperStyle={{ marginTop: 0 }}
            />
          </div>

          <div className="filters-col">
            <RoundedSearchTextField
              style={{ width: "100%" }}
              expandable
              inlineButton
              search={search}
              values={moduleSearchExpression}
              onTextChange={(value) => {
                const trimmed = (value || "").trim();
                if (trimmed === "") {
                  setSearchText("");
                  if (searchInitated) handleClearSearchOnly();
                } else {
                  setSearchText(value);
                  setIsSearchBarEmpty(false);
                }
              }}
              handleSearch={initiateSearch}
              searchReference={searchReference}
              inputValue={searchText}
              searchText={searchText}
              setSearchText={setSearchText}
              setIsSearchBarEmpty={setIsSearchBarEmpty}
              isSearchBarEmpty={isSearchBarEmpty}
              placeholder="Search by Name / ID"
              setValues={setValues}
              handleReset={handleClearSearchOnly}
              searchInitated={searchInitated}
            />
          </div>

          <Button
            className="moduleResetButton"
            onClick={handleResetAllFilters}
            disabled={!searchInitated && selectedIndications.length === 0}
          >
            RESET FILTERS
          </Button>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginLeft: "15px",
            marginRight: "15px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              fontWeight: 500,
              color: "#1C3557",
              paddingLeft: "5px",
            }}
          >
            All ({modulesData?.length || 0})
          </div>

          <div
            style={{
              flexGrow: 1,
              height: "1px",
              backgroundColor: "#DADADA",
              margin: "0 8px",
            }}
          />

          <div className=" d-flex showselectedSwitch">
            Show All Selected
            <Switch
              checked={selectedChecked}
              onChange={(e) => {
                handleSwitchComp(e, "moduleCards");
                handleOpenModal("moduleCards");
              }}
              disabled={selectedModulecards?.length > 0 ? false : true}
              style={{
                width: 26,
                height: 13,
                padding: 0,
                display: "flex",
                marginLeft: -10,
                marginBottom: 2,
              }}
              classes={{
                thumb: "customSwitchThumb",
                switchBase: "customSwitchBase",
                track: "customSwitchTrack",
              }}
            />
            {contextMenu && (
              <>
                <div className=" showAllselectedMenu d-flex">
                  <p>
                    Associated module(s) from other topics have been added based
                    on defined business rule(s)
                  </p>
                  <div className="crossImage">
                    <img
                      src={clearTextIcon}
                      alt=""
                      className="img-fluid crossImageicon"
                      onClick={handleCloseContextMenu}
                    />
                  </div>
                </div>
                <div className="contextMenuarrow" id="contextMenuarrow"></div>
              </>
            )}
          </div>
        </div>

        {isLoading && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />
          </>
        )}

        <div className="">
          {isLoading && modulesData.length === 0 ? null : (
            <InfiniteScroll
              dataLength={modulesData?.length}
              next={() => handlePageChange(currentPage + 1)}
              hasMore={hasMore}
              scrollableTarget="scrollableDiv"
              scrollThreshold={0.9}
            >
              <div
                className={
                  modulesData.length > 0
                    ? `row modulleCardsRowM  recentlyVeiwedcrollBar`
                    : `row modulleCardsRowM recentlyVeiwedcrollBar noResultsContainer`
                }
                id="scrollableDiv"
                ref={scrollableDivRef}
              >
                <div className="moduleDataCards" style={{ height: "244px" }}>
                  {modulesData.length > 0 ? (
                    modulesData?.map((item) => (
                      <div
                        className="moduleCardBlock"
                        key={item.id || item.moduleDamName}
                      >
                        <ModuleCardNew
                          moduledata={modulesData}
                          cardData={item}
                          selectDeselectModule={() =>
                            selectDeselectModule(item)
                          }
                          selectedModulecards={selectedModulecards}
                          createdDate={createdDate}
                          active={selectedModulecards.some(
                            (card) => card.moduleDamName === item.moduleDamName
                          )}
                          displayRulesClass={displayRulesClass(item.id)}
                          getModuleDetailsForPreview={
                            getModuleDetailsForPreview
                          }
                        />
                      </div>
                    ))
                  ) : (
                    <div className="noresultsImage" style={{ height: "80px" }}>
                      <img
                        className="img-fluid"
                        src={NoResultsFound}
                        alt="No Results"
                      />
                    </div>
                  )}
                </div>
              </div>
            </InfiniteScroll>
          )}
        </div>

        <div>
          <div className="row bsRulesBtnRow align-items-center">
            <div className="col-md-5 text-left cannotExistSelctedMod">
              <img src={checkMark} alt="First Image" className="img-fluid" />
              <span>Selected Module</span>
              <img
                src={CannotExist}
                alt="Second Image"
                className="img-fluid"
              />{" "}
              <span>Cannot exist with</span>
              <img
                src={MustExist}
                alt="Second Image"
                className="img-fluid"
              />{" "}
              <span>Must use or Related (Optional)</span>
            </div>
            <div className="col-md-7 text-right ">
              <button
                className="btn btn-link  bsRulecancelBtn bsRuleBAckBtn"
                onClick={() => setShowConfirmation(true)}
              >
                CANCEL
              </button>

              <Button
                onClick={() => {
                  setRemoveSymbol(true)
                  handleGotoEditor();
                  setOpenRuleSetModal(false);
                  setOpenModulesModal(false);
                  setOpenModulesScreen(false);
                  setIsNext(true);
                  setBgClass(false);
                  // localStorage.removeItem("modulesSelected");
                }}
                type="submit"
                className="moduleNext-btn"
                disabled={selectedModulecards?.length > 0 ? false : true}
                style={
                  selectedModulecards?.length > 0
                    ? { cursor: "" }
                    : { cursor: "not-allowed" }
                }
                autoFocus
              >
                NEXT
              </Button>
            </div>
          </div>
        </div>
      </div>

      <BannerConfirmationModal
        showConfirmation={showConfirmation}
        handleCancel={handleCancel}
        handleProceed={handleProceed}
      />
    </div>
  );
};

export default ModulesScreen;
